// HN Shop mega panel (MSH Studios): swap the preview rack to the category the shopper
// is pointing at. Hover intent: the swap waits until the pointer rests on a category,
// so moving across rows toward the products never changes the rack mid-trip.
// Keyboard focus swaps immediately.
const REST_MS = 180; // 120 swapped racks mid-travel when the live page stalled the main thread (QA r20261008-01..03)
const REST_PX = 4;
let timer = null;
let anchor = null;
let moves = 0; // bumped on every re-arm; a pending swap only lands if no move came in since
const show = (panel, id) => {
  const target = panel.querySelector(`[data-hn-rack][id="${CSS.escape(id)}"]`);
  if (!target) return;
  panel.querySelectorAll('[data-hn-target]').forEach((link) => {
    link.classList.toggle('is-current', link.dataset.hnTarget === id);
  });
  if (!target.hidden) return;
  panel.querySelectorAll('[data-hn-rack]').forEach((rack) => { rack.hidden = rack !== target; });
};
const targetOf = (el) => {
  const link = el?.closest?.('[data-hn-target]');
  const panel = link?.closest('[data-hn-panel]');
  return link && panel ? [panel, link.dataset.hnTarget] : null;
};
const arm = (event) => {
  clearTimeout(timer);
  anchor = { x: event.clientX, y: event.clientY };
  const armed = ++moves;
  const hit = targetOf(event.target);
  // After a main-thread stall the timer can fire before the pointer moves queued during
  // the stall are delivered. Those moves are dispatched before the next animation frame,
  // so confirm the rest there: any move in between cancels the swap.
  if (hit) timer = setTimeout(() => requestAnimationFrame(() => { if (moves === armed) show(...hit); }), REST_MS);
};
if (!window.hnMegaPanelReady) {
  window.hnMegaPanelReady = true;
  document.addEventListener('pointermove', (event) => {
    if (event.pointerType && event.pointerType !== 'mouse') return;
    if (!event.target.closest?.('[data-hn-panel]')) { clearTimeout(timer); anchor = null; moves++; return; }
    if (anchor && Math.hypot(event.clientX - anchor.x, event.clientY - anchor.y) < REST_PX) return;
    arm(event);
  });
  document.addEventListener('focusin', (event) => {
    const hit = targetOf(event.target);
    if (hit) { clearTimeout(timer); show(...hit); }
  });
  // Re-opening a group starts from its hand-picked items, not the last category viewed.
  const reset = (event) => {
    const top = event.target.closest?.('.menu-list__link, .menu-list__disclosure');
    const panel = top?.closest('.menu-list__list-item')?.querySelector('[data-hn-panel]');
    const first = panel?.querySelector('[data-hn-rack]');
    if (panel && first && first.hidden) show(panel, first.id);
  };
  document.addEventListener('pointerover', reset);
  document.addEventListener('focusin', reset);
  // Phone drawer Escape (DL-0009). Savor 4.2 closes the details nearest the focus, so Escape
  // on a group row (a closed submenu) did nothing, and closing a submenu dropped focus to the
  // page. Escape now closes the open submenu and returns focus to its row, else the drawer.
  document.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape') return;
    const drawer = event.target.closest?.('header-drawer');
    const main = drawer?.querySelector('details');
    if (!main?.open) return;
    event.stopPropagation();
    const sub = event.target.closest('details[open]');
    if (sub && sub !== main) {
      const row = sub.querySelector('summary');
      drawer.back({ target: sub });
      const watch = new MutationObserver(() => { if (!sub.open) { watch.disconnect(); row?.focus(); } });
      watch.observe(sub, { attributes: true, attributeFilter: ['open'] });
      setTimeout(() => watch.disconnect(), 2000);
    } else {
      drawer.close();
      main.querySelector('summary')?.focus();
    }
  }, true);
  // Desktop Escape for a panel opened by hover (DL-0011). Savor listens for Escape on the
  // header menu only, and a mouse user's focus sits on the page, so hand the key to it.
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || event.defaultPrevented) return;
    const menu = [...document.querySelectorAll('header-menu')].find((el) => el.ariaExpanded === 'true');
    if (!menu || menu.contains(event.target)) return;
    menu.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
  });
}
